module.exports = __webpack_public_path__ + "bf28241e67511184c14dbd0ef7d39f91.woff2";